import { render, staticRenderFns } from "./LegacyLatenessSection.vue?vue&type=template&id=cf2fdaea"
import script from "./LegacyLatenessSection.vue?vue&type=script&lang=js"
export * from "./LegacyLatenessSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports